
import React from 'react';
import EventCard from './EventCard';
import { EventWithStatus } from '@/types/event';

interface EventGridProps {
  events: EventWithStatus[];
  isLoading: boolean;
  onRegister?: (event_id: string) => void;
  registeredEvents?: string[];
}

const EventGrid: React.FC<EventGridProps> = ({ 
  events, 
  isLoading, 
  onRegister,
  registeredEvents = []
}) => {
  if (isLoading) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Chargement des événements...</p>
      </div>
    );
  }
  
  if (events.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Aucun événement trouvé</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {events.map(event => (
        <EventCard 
          key={event.id} 
          event={event} 
          onRegister={onRegister}
          isRegistered={registeredEvents.includes(event.id)}
        />
      ))}
    </div>
  );
};

export default EventGrid;
